import { GetBillingDetailed } from 'domain/usecases/billing/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetBillingDetailed implements GetBillingDetailed {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetBillingDetailed.Model>;

  constructor(url: string, httClient: HttpClient<GetBillingDetailed.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  post = async (
    params: GetBillingDetailed.Params,
  ): Promise<GetBillingDetailed.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: {
        begin: params.begin,
        end: params.end,
        org: params.orgId,
        orgUnit: params.orgUnit,
        user: params.user,
        service: params.service,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
